<app-header></app-header>

<div class="wrapper">

    <div class="banner-img-name">
        <div class="main" style="padding-bottom: 0;">
            <h2>Dashboard</h2>
        </div>
    </div>

    <div class="main">
        <div class="instruction_box_2 mt30">
            <h4>Instructions For Family and Group Applications:</h4>
            <h3>To add a dependent to your visa application</h3>
            <ul>
                <li>First, start to fill your own visa application (as a parent or guardian).</li>
                <li>On the second page of the application (Biodata page), kindly select the add dependent option at the
                    lower left hand side of the page.
                </li>
                <li>Complete the dependent's application and upload the required supporting document.</li>
                <li>You are allowed to add up to a maximum of 4 dependents.</li>
                <li>NOTE: Dependents cannot apply independently and must be 18years and below.</li>
            </ul>
        </div>
    </div>

    <section class="main">

        <form action="" method="post" name="dashboardForm" autocomplete="off">
            <input type="hidden" name="loggedUserId" value="" />
        </form>

        <div class="legends right_legend">

            <div class="align-right">

                <span *ngIf="currentTab === constants.INCOMPLETE"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i>
                    <p class="">Edit Application |</p>
                </span>

                <span *ngIf="currentTab === constants.UNPAID || currentTab === constants.PAID"><i class="fa fa-eye"
                        aria-hidden="true"></i>
                    <p class="">View/Print Application <ng-container
                            *ngIf="currentTab === constants.UNPAID">|</ng-container></p>
                </span>

                <span *ngIf="currentTab === constants.INCOMPLETE || currentTab === constants.UNPAID"><i
                        class="fa fa-trash" aria-hidden="true"></i>
                    <p class="">Delete Application <ng-container
                            *ngIf="currentTab === constants.UNPAID">|</ng-container></p>
                </span>

                <span *ngIf="currentTab === constants.UNPAID"><i class="fa fa-refresh" aria-hidden="true"></i>
                    <p class="">Check Status of payment </p>
                </span>

            </div>

        </div>

        <div class="new_app">

            <input *ngIf="currentTab === constants.UNPAID" class="custom_btn pay_btn" type="button"
                value="Pay For Others" (click)="openSearchModel()">

            <input type="button" class="save_btn" value="Create new application" (click)="openApplicationForm()">

        </div>

        <div class="tabset">

            <input type="radio" name="currentTab" [value]="constants.INCOMPLETE" [(ngModel)]="currentTab" id="tab1"
                aria-controls="incomplete">
            <label for="tab1" style="border-left: 1px solid #bdc4c0;">Incomplete Applications
                ({{incompleteApplicationsList?.length}})</label>

            <input type="radio" name="currentTab" [value]="constants.UNPAID" [(ngModel)]="currentTab" id="tab2"
                aria-controls="unpaid">
            <label for="tab2">Unpaid Applications ({{completedApplicationsList?.length}})</label>

            <input type="radio" name="currentTab" [value]="constants.PAID" [(ngModel)]="currentTab" id="tab3"
                aria-controls="paid">
            <label for="tab3">Paid Applications ({{paidApplicationsList?.length}})</label>

            <div class="tab-panels">

                <section *ngIf="currentTab === constants.INCOMPLETE" id="incomplete" class="tab-panel">

                    <table width="100%">

                        <thead>
                            <th *ngFor="let headingObject of incompleteTableHeadings;"
                                [width]="headingObject.width + '%'">{{headingObject.label}}</th>
                        </thead>

                        <tbody>
                            <tr *ngFor="let pendingApplication of incompleteApplicationsList;">
                                <td data-label="Applicant Name" scope="row">{{pendingApplication.fullName}}</td>
                                <td data-label="Date Of Birth"><span>{{pendingApplication.dateOfBirth}}</span></td>
                                <td data-label="Application No.">{{pendingApplication.applicationId}}</td>
                                <td data-label="Reference No."><span>{{pendingApplication.referenceId}}</span></td>
                                <td data-label="Action">
                                    <span tooltip="Edit" placement="bottom"
                                        (click)="editApplication(pendingApplication.applicantId, pendingApplication.stage)"
                                        style="margin-right: 5px;"><i class="fa fa-pencil-square-o"
                                            aria-hidden="true"></i></span>
                                    <span tooltip="Delete" placement="bottom"
                                        (click)="showDeleteConfirmation(pendingApplication.applicantId, pendingApplication.applicationId, constants.TRUE)"
                                        style="margin-right: 5px;"><i class="fa fa-trash" aria-hidden="true"></i></span>
                                </td>
                            </tr>
                            <tr *ngIf="incompleteApplicationsList?.length === 0">
                                <td colspan="5" style="text-align:left;">No record found</td>
                            </tr>
                        </tbody>

                    </table>

                </section>

                <section *ngIf="currentTab === constants.UNPAID" id="unpaid" class="tab-panel">

                    <div class="height_fixx">

                        <table width="100%" style="margin-bottom:0px;">

                            <thead>
                                <th style="width:30px;"></th>
                                <!-- <th style="width:30px;"><input type="checkbox" [(ngModel)]="selectedAllApplications"
                                        (change)="selectAllCompletedApplications()" /></th> -->
                                <th style="width:25%;">Applicant Name</th>
                                <th style="width:15%;">Date Of Birth</th>
                                <th style="width:17%;">Application No.</th>
                                <th style="width:17%;">Reference No.</th>
                                <th style="width:10%;" style="text-align:right;">Total Amount</th>
                                <th style="width:10%;">Action</th>
                            </thead>

                            <tbody>
                                <tr *ngFor="let completedApplication of completedApplicationsList;"
                                    [ngStyle]="{'background': completedApplication.applicationExpiryStatus === constants.TRUE ? '#f0d8d8' : '#ffffff'}">
                                    <td style="width:30px;padding-left:6px;" data-label="Select" scope="row"
                                        class="mark">
                                        <input
                                            *ngIf="completedApplication.applicationFee > constants.FALSE && completedApplication.applicationExpiryStatus === constants.FALSE"
                                            type="checkbox" [(ngModel)]="completedApplication.selected"
                                            (change)="checkIfAllCompletedApplicationsSelected(completedApplication)" />
                                    </td>
                                    <td data-label="Applicant Name" scope="row">{{completedApplication.fullName}}</td>
                                    <td data-label="Date Of Birth"><span>{{completedApplication.dateOfBirth}}</span>
                                    </td>
                                    <td data-label="Application No.">{{completedApplication.applicationId}}</td>
                                    <td data-label="Reference No."><span>{{completedApplication.referenceId}}</span>
                                    </td>
                                    <td data-label="Total Amount" style="text-align:right;">
                                        {{completedApplication.currencySymbol}} {{completedApplication.applicationFee}}
                                    </td>
                                    <td data-label="action">
                                        <span (click)="viewApplication(completedApplication.applicantId)" tooltip="View"
                                            placement="bottom" style="margin-right: 5px;"><i class="fa fa-eye"
                                                aria-hidden="true"></i></span>
                                        <span
                                            (click)="showDeleteConfirmation(completedApplication.applicantId, completedApplication.applicationId, constants.FALSE)"
                                            tooltip="Delete" placement="bottom" style="margin-right: 5px;"><i
                                                class="fa fa-trash" aria-hidden="true"></i></span>
                                        <span *ngIf="completedApplication.isAddedToCart === constants.TRUE"
                                            (click)="checkPaymentStatus(completedApplication.applicantId)"
                                            tooltip="Check Payment Status" placement="bottom"
                                            style="margin-right: 5px;"><i class="fa fa-refresh"
                                                aria-hidden="true"></i></span>
                                    </td>
                                </tr>
                                <tr *ngIf="completedApplicationsList?.length === 0">
                                    <td colspan="7" style="text-align:left;">No record found</td>
                                </tr>
                            </tbody>

                        </table>

                    </div>
                    <div class="fr mt10">
                        <span><i class="fa fa-circle"
                                style="color: #f0d8d8; background-color: #f0d8d8; border: 1px solid #aaa22c;"></i>
                            Expired Application</span>
                    </div>
                    <div class="mark_btn">
                        <input type="button" (click)="initiatePayment()" [disabled]="selectedApplicationsCount === 0"
                            class="action-button custom_btn"
                            value="Pay {{masterCurrencySymbol}}{{selectedApplicationsAmount}}" />
                        <p *ngIf="selectedApplicationsCount > 0">You have selected {{selectedApplicationsCount}}
                            applications</p>
                    </div>

                </section>

                <section *ngIf="currentTab === constants.PAID" id="paid" class="tab-panel">

                    <table width="100%">

                        <thead>
                            <th style="width:25%;">Applicant Name</th>
                            <th style="width:15%;">Date Of Birth </th>
                            <th style="width:15%;">Application No.</th>
                            <th style="width:15%;">Reference No.</th>
                            <th style="width:10%;" style="text-align:right;">Total Amount</th>
                            <th style="width:10%;">Payment Date</th>
                            <th style="width:10%;">Action</th>
                        </thead>

                        <tbody>
                            <tr *ngFor="let paidApplication of paidApplicationsList;"
                                [ngStyle]="{'background': paidApplication.applicationExpiryStatus === constants.TRUE ? '#f0d8d8' : '#ffffff'}">
                                <td scope="row" data-label="Applicant Name">{{paidApplication.fullName}}</td>
                                <td data-label="Date Of Birth"><span>{{paidApplication.dateOfBirth}}</span></td>
                                <td data-label="Application No.">{{paidApplication.applicationId}}</td>
                                <td data-label="Reference No."><span>{{paidApplication.referenceId}}</span></td>
                                <td data-label="Total Amount" style="text-align:right;">
                                    {{paidApplication.currencySymbol}} {{paidApplication.applicationFee}}</td>
                                <td data-label="payment Date">{{paidApplication.paymentDate}}</td>
                                <td data-label="Action">
                                    <span tooltip="View" placement="bottom"
                                        (click)="viewApplication(paidApplication.applicantId)"
                                        style="margin-right: 5px;"><i class="fa fa-eye" aria-hidden="true"></i></span>
                                </td>
                            </tr>

                            <tr *ngIf="paidApplicationsList?.length === 0">
                                <td colspan="7" style="text-align:left;">No record found</td>
                            </tr>
                        </tbody>

                    </table>

                    <div style="text-align:right;">
                        <span><i class="fa fa-circle"
                                style="color: #f0d8d8; background-color: #f0d8d8; border: 1px solid #aaa22c;"></i>
                            Expired Application</span>
                    </div>

                </section>

            </div>

        </div>

    </section>

</div>

<app-footer></app-footer>